const initialState = 50

export const addData = (state = initialState, action: { type: string }) => {
    switch (action.type) {
        case "INCREMENT": return state + 1;
        case "DECREMENT": return state - 1;
        default: return state
    }
}